import { useEffect, useState, useRef } from "react";
import FormField, { STYLE } from "components/FormField";
import Checkbox from "components/Checkbox";
import ContentHeader from "../ContentHeader";

import styles from "./TruckInfo.module.scss";

const TruckInfo = ({ fetchData, updateData, errors }) => {
  const {boxLErr,boxWErr, boxHErr, maxPErr, noteErr} = errors
  const [boxL, setBoxL] = useState(null)
  const [boxW, setBoxW] = useState(null)
  const [boxH, setBoxH] = useState(null)
  const [maxP, setMaxP] = useState(null)

  const [airRide, setAirRide] = useState(false)
  const [liftGate, setLiftGate] = useState(false)
  const [palletJack, setPalletJack] = useState(false)
  const [dockHigh, setDockHigh] = useState(false)

  const [truckNotes, settruckNotes] = useState("")

  const prevBoxLRef = useRef(boxL);
  const prevBoxWRef = useRef(boxW);
  const prevBoxHRef = useRef(boxH);
  const prevMaxPRef = useRef(maxP);

  const handleChangeNotes = (e) => {
    settruckNotes(e.target.value);
  };

  useEffect(()=> {
    const prevBoxL = prevBoxLRef.current;
    const prevBoxW = prevBoxWRef.current;
    const prevBoxH = prevBoxHRef.current;
    const prevMaxP = prevMaxPRef.current;


    if (prevBoxL !== boxL) updateData('length', null, boxL);
    if (prevBoxW !== boxW) updateData('width', null, boxW);
    if (prevBoxH !== boxH)  updateData('height', null, boxH);
    if (prevMaxP !== maxP) updateData('payload', null, maxP);
    updateData('air_ride', null, airRide);
    updateData('lift_gate', null, liftGate);
    updateData('dock_high', null, dockHigh);
    updateData('pallet_jack', null, palletJack);
    updateData('truck_note', null, truckNotes);

    prevBoxLRef.current = boxL;
    prevBoxWRef.current = boxW;
    prevBoxHRef.current = boxH;
    prevMaxPRef.current = maxP;

  }, [boxL, boxH, boxW, maxP, airRide, liftGate, palletJack, dockHigh, truckNotes])

  return (
    <>
    <div className={styles.wrapper}>
      <ContentHeader
        title="Truck Info"
        className={styles.header}
      />

      <div className={styles.group}>
        <div className={styles.group_item}>
          <label className={styles.label}>
            Box Length, in <span className={styles.red}>*</span>
          </label>
            <div className={styles.group_item_form}>
              <FormField
                value={boxL?.slice(0, 4)}
                style={STYLE.FORM_SMALL}
                onChange={(e) => setBoxL(e.target.value)}
                error={boxLErr ? true : false}
                errorMessage={boxLErr}
                className={styles.errorMessage}
              />
            </div>
        </div>
        <div className={styles.group_item}>
          <label className={styles.label}>
            Box Width, in <span className={styles.red}>*</span>
          </label>
          <div className={styles.group_item_form}>
            <FormField
              value={boxW?.slice(0, 4)}
              style={STYLE.FORM_SMALL}
              onChange={(e) => setBoxW(e.target.value)}
              error={boxWErr ? true : false}
              errorMessage={boxWErr}
              className={styles.errorMessage}
            />
          </div>
        </div>
        <div className={styles.group_item}>
          <label className={styles.label}>
            Box Height, in <span className={styles.red}>*</span>
          </label>
          <div className={styles.group_item_form}>
            <FormField
              value={boxH?.slice(0, 4)}
              style={STYLE.FORM_SMALL}
              onChange={(e) => setBoxH(e.target.value)}
              error={boxHErr ? true : false}
              errorMessage={boxHErr}
              className={styles.errorMessage}
            />
          </div>
        </div>
        <div className={styles.group_item}>
          <label className={styles.label}>
            Max Payload, lb <span className={styles.red}>*</span>
          </label>
          <div className={styles.group_item_form}>
            <FormField
              value={maxP?.slice(0, 6)}
              style={STYLE.FORM_SMALL}
              onChange={(e) => setMaxP(e.target.value)}
              error={maxPErr ? true : false}
              errorMessage={maxPErr}
              className={styles.errorMessage}
            />
          </div>
        </div>
        <div className={styles.group_item}>
            
            <div className={styles.checkbox}>              
              <Checkbox
                id="Air"
                label="Air Ride"
                value={airRide}
                onChange={() => setAirRide(!airRide)}
                className={styles.checkbox}
              />
            </div>
            

            <div className={styles.checkbox}>  
              <Checkbox
                id="Lift"
                label="LiftGate"
                value={liftGate}
                onChange={() => setLiftGate(!liftGate)}
                className={styles.checkbox}
              />
            </div>
          </div>
          <div className={styles.group_item}>
            
            <div className={styles.checkbox}>              
              <Checkbox
                id="Pallet"
                label="Pallet Jack"
                value={palletJack}
                onChange={() => setPalletJack(!palletJack)}
                className={styles.checkbox}
              />
            </div>
            

            <div className={styles.checkbox}>  
              <Checkbox
                id="Dock"
                label="Dock High"
                value={dockHigh}
                onChange={() => setDockHigh(!dockHigh)}
                className={styles.checkbox}
              />
            </div>
          </div>
      </div>

      <label className={styles.label}>
        Truck Note 
      </label>
      <FormField
          fieldName="notes"
          style={STYLE.NOTE}
          onChange={handleChangeNotes}
          value={truckNotes}
          className={styles.errorMessage_note}
          error={noteErr ? true : false}
          errorMessage={noteErr}
      />
    </div>
    </>
  );
};

export default TruckInfo;
